"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var helper_util_1 = require("../util/helper.util");
/**
 * @author by Gor.Hakobyan on 13-May-19.
 */
var ReportDataToTrackingDataConverter = /** @class */ (function () {
    function ReportDataToTrackingDataConverter(reportData, frequency, measure, disGroupId) {
        this.reportData = reportData;
        this.frequency = frequency;
        this.measure = measure;
        this.disGroupId = disGroupId;
        this.reportData = reportData;
        this.frequency = frequency;
        this.measure = measure;
        this.disGroupId = disGroupId;
    }
    ReportDataToTrackingDataConverter.prototype.convert = function (dataPointId) {
        var _this = this;
        if (!this.reportData) {
            throw new Error('Invalid input parameter(s)');
        }
        var keys = new Map();
        var disaggregation = [];
        var measureIndex = this.reportData.metadata.findIndex(function (item) { return item.type === 'MEASURE'; });
        this.reportData.metadata.forEach(function (item, index) {
            keys.set(item.systemName, index);
            if (item.type === 'DISAGGREGATION') {
                disaggregation.push(item.systemName);
            }
        });
        disaggregation.sort(function (a, b) { return a > b ? 1 : -1; });
        var object, obj;
        object = obj = {};
        var frequencyName = ReportDataToTrackingDataConverter.getFrequencyNameById(this.frequency);
        if (frequencyName && frequencyName !== 'once') {
            obj = obj[frequencyName] = {};
        }
        else {
            obj = obj['once'] = {};
            obj = obj['-1'] = {};
        }
        this.reportData.data.forEach(function (arr) {
            var obj2 = obj;
            if (frequencyName && frequencyName !== 'once') {
                var frequencyKey = helper_util_1.Helper.getFrequencyNameById(_this.frequency);
                if (!obj2[arr[keys.get(frequencyKey)]]) {
                    obj2[arr[keys.get(frequencyKey)]] = {};
                }
                obj2 = obj2[arr[keys.get(frequencyKey)]];
            }
            if (_this.disGroupId && arr[keys.get(disaggregation[0])]) {
                if (!obj2['groups']) {
                    obj2['groups'] = {};
                }
                obj2 = obj2['groups'];
                if (!obj2[_this.disGroupId.toString()]) {
                    obj2[_this.disGroupId.toString()] = {};
                }
                obj2 = obj2[_this.disGroupId.toString()];
                for (var i = 0; i < disaggregation.length; i++) {
                    if (!obj2['disaggregations']) {
                        obj2['disaggregations'] = {};
                    }
                    obj2 = obj2['disaggregations'];
                    if (!obj2[arr[keys.get(disaggregation[i])]]) {
                        obj2[arr[keys.get(disaggregation[i])]] = {};
                    }
                    obj2 = obj2[arr[keys.get(disaggregation[i])]];
                    if (i === disaggregation.length - 1 || !arr[keys.get(disaggregation[i + 1])]) {
                        if (!obj2['dataPoints']) {
                            obj2['dataPoints'] = {};
                        }
                        obj2 = obj2['dataPoints'];
                        obj2[dataPointId] = arr[measureIndex];
                        break;
                    }
                }
            }
            else {
                if (!obj2['dataPoints']) {
                    obj2['dataPoints'] = {};
                }
                obj2 = obj2['dataPoints'];
                obj2[dataPointId] = arr[measureIndex];
            }
        });
        return object;
    };
    ReportDataToTrackingDataConverter.getFrequencyNameById = function (frequency) {
        if (!frequency) {
            return null;
        }
        switch (frequency) {
            case (1):
                return 'once';
            case (2):
                return 'years';
            case (3):
                return 'semiAnnual';
            case (4):
                return 'quarters';
            case (5):
                return 'months';
            case (6):
                return 'weeks';
            case (7):
                return 'days';
            default:
                throw Error('Mistake frequency id');
        }
    };
    return ReportDataToTrackingDataConverter;
}());
exports.ReportDataToTrackingDataConverter = ReportDataToTrackingDataConverter;
//# sourceMappingURL=report-data-to-tracking-data.converter.js.map